import React from "react";

import { CAUSED_BY_FRONT } from "../utils/constants";
import { withAuditoryCrashlytics } from "../provider/hooks";

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const code = CAUSED_BY_FRONT;
    const message = error.message;
    const stack = errorInfo.componentStack;

    withAuditoryCrashlytics({
      code,
      message,
      stack,
      error,
    });
  }

  render() {
    if (this.state.hasError) {
      const Fallback = this.props.fallback;
      return <Fallback />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
